import { CircleMarker, Tooltip } from 'react-leaflet';


/**
 * エリアの除雪出動確率をマップに重畳表示するためのコンポーネント
 *
 * Tooltipの表示場所を緯度経度で指定するために、
 * TooltipをダミーのCircleMarkerの子要素としている。
 * 
 * @param {Object} props - コンポーネントに渡されるプロパティ
 * @param {string} props.areaName - エリア名
 * @param {Array} props.position - 表示座標 [lat, lng]
 * @param {string} props.color - エリアの色（トップページのエリア色と合わせる前提）
 * @param {number} props.rate - 除雪出動確率（0から1の範囲の値）
 * 
 * @returns {JSX.Element} - 地図上に表示されるコンポーネント
 */
const AreaToolTip = (props) => {
    const { areaName, position, color, rate } = props;

    const areaNameStyle = {
        backgroundColor: color,
        borderRadius: '6px',
        color: 'white',
        fontSize: 16,
        fontWeight: 'bold',
        height: '20px',
        opacity: 0.9,
        padding: 6,
        textAlign: 'center',
        width: 'auto',
    };

    const valueStyle = {
        color: color,
        fontSize: 18,
        fontWeight: 'bold',
        opacity: 0.9,
        padding: 0,
        textAlign: 'center',
        width: 'auto',
    };

    return (
        // CircleMarkerはダミーなので、透明化する
        <CircleMarker
            center={position}
            pathOptions={{ color: 'transparent' }}
            radius={0}>

            <Tooltip opacity={0.9} direction="center" offset={[0, 20]} permanent>
                <div className='el_tooltip-areaname' style={areaNameStyle}>
                    { areaName }
                </div>
                <div className='el_tooltip-value' style={valueStyle}>
                    {Math.round(rate * 1000) / 10}%
                </div>
            </Tooltip>
        </CircleMarker>
    );
};

export default AreaToolTip;
